import { post2 } from "@/shared/axios";
import useDownloadHubQuery from "@/shared/queries/downloads/useDownloadHubQuery";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useDownloadHubPost = () => {
  const { t } = useTranslation();
  const query = useDownloadHubQuery();

  const mutation = useMutation({
    mutationFn: (data: any) =>
      post2(`internal/secure/pos/v1/download/hub`, data),
    onSuccess: () => {
      toast.success(t("success.success"));
      query.refetch();
    },
  });

  return mutation;
};

export default useDownloadHubPost;
